/**
 * Help index page.
 * Displays a list of available help topics as clickable cards.
 *
 * @module pages/help/HelpIndex
 */

import React        from 'react';
import { Link }     from 'react-router-dom';
import { CircleHelp } from 'lucide-react';
import Layout       from '../../components/Layout';
import { useI18n }  from '../../dataProviders/I18nProvider';
import helpTopicRegistry from './helpTopicRegistry';

/**
 * Renders the help topic index page.
 *
 * @returns {React.ReactElement}
 */
export default function HelpIndex() {
  const { t } = useI18n();

  return (
    <Layout title={t('page.help')}>
      <div className="help-index">
        <p className="help-index-intro">{t('help.index.intro')}</p>
        <ul className="help-topic-list">
          {helpTopicRegistry.map((topic) => (
            <li key={topic.slug}>
              <Link to={`/help/${topic.slug}`} className="help-topic-card">
                <CircleHelp size={20} className="help-topic-card-icon" />
                <div>
                  <h3 className="help-topic-card-title">{t(topic.titleKey)}</h3>
                  <p className="help-topic-card-desc">{t(topic.descriptionKey)}</p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </Layout>
  );
}
